import { IEvent, IEventRes, IDropdownResponse } from './../models';
import axios, { AxiosResponse } from 'axios';

import { authFetch } from './fetch';

const baseUrl = '/api/Admin/Event';

export const IEventAPI = {
  async getAll(filters?: {
    page?: number;
    perPage?: number;
    sortBy?: string;
    sortDirection?: string;
  }): Promise<IEventRes> {
    try {
      const response: AxiosResponse<IEventRes> = await authFetch.get(baseUrl, filters);

      if (!(response.status >= 200 && response.status < 300)) {
        throw Error(response.statusText);
      }

      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        throw Error(error?.response?.data);
      }
      throw error;
    }
  },

  async upsert(upsertData: IEvent): Promise<IEvent> {
    try {
      const payload = { event: upsertData };
      const response: AxiosResponse<IEvent> = await authFetch.put(baseUrl, payload);

      if (!(response.status >= 200 && response.status < 300)) {
        throw Error(response.statusText);
      }

      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        throw Error(error?.response?.data);
      }
      throw error;
    }
  },

  async delete(eventId: number): Promise<void> {
    try {
      const response = await authFetch.delete(`${baseUrl}/${eventId}`);

      if (!(response.status >= 200 && response.status < 300)) {
        throw Error(response.statusText);
      }

      return;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        throw Error(error?.response?.data?.Detail);
      }
      throw error;
    }
  },
};

export const getEventTypes = async (): Promise<IDropdownResponse[]> => {
  try {
    const { data } = await authFetch.get(`${baseUrl}/lookup/event-types`);
    return data;
  } catch (error) {
    return Promise.reject(error);
  }
};